// @ts-nocheck
export const observeDOM = (obj: HTMLElement | null, callback: (mutationRecords?: MutationRecord[]) => void) => {
    if (!obj) {
        console.log('n');
        return;
    }
    let MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
        // define a new observer
        const mutationObserver = new MutationObserver(callback)
        // have the observer observe for changes in children
        const config = {attributes: true, childList: true, subtree: true};
        mutationObserver.observe(obj, config)
        return mutationObserver
    }

    // browser support fallback
    else if (window.addEventListener) {
        obj.addEventListener('DOMNodeInserted', callback, false)
        obj.addEventListener('DOMNodeRemoved', callback, false)
    }
}